// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SUMMARY */

.summary_row {
    margin-top: 2px;
    margin-bottom: 6px;
}
.summary_row > p {
    font-size: 11px;
    font-weight: 500;
    color: #767493;
    letter-spacing: 0.5px;
}
.summary_dot {
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    border-radius: 50%;
    margin-right: 5px;
}
.red_summary {
    background-color: #FF5242;
}
.blue_summary {
    background-color: #6457E8;
}
.summary_stat {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 20px;
    margin-bottom: 6px;
}
.summary_stat > p {
    font-size: 11px;
    font-weight: 500;
    color: #767493;
    letter-spacing: 0.5px;
    margin-right: 7px;
    text-align: right;
    vertical-align: baseline;
}
.summary_stat > span {
    font-size: 12px;
    padding-left: 7px;
    font-weight: 600;
}

.summary_stat > img {
    margin-left: 10px;
    padding-bottom: 2px;
}

@media (max-width: 1300px) {
    .summary_opt_container {
        height: 30px;
        font-size: 12px;
        min-width: 120px;
    }
    .summary_opt {
        padding: 3px;
    }
    .summary_opt_selected {
        padding: 5px;
    }
}
.summary_chart_container {
    max-width: 100%;
    width: 100%;
    padding-top: 20px;
    height: 320px;
}

@media (max-width: 400px) {
    .summary_opt_container {
        position: absolute;
        right: 10px;
        top: 46px;
    }
}
@media (max-width: 350px) {
    .summary_opt_container {
        right: 10px;
        top: 60px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/DashboardCharts/SummaryChart.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;AACJ;AACA;IACI;QACI,WAAW;QACX,SAAS;IACb;AACJ","sourcesContent":["/* SUMMARY */\n\n.summary_row {\n    margin-top: 2px;\n    margin-bottom: 6px;\n}\n.summary_row > p {\n    font-size: 11px;\n    font-weight: 500;\n    color: #767493;\n    letter-spacing: 0.5px;\n}\n.summary_dot {\n    width: 10px;\n    height: 10px;\n    min-width: 10px;\n    min-height: 10px;\n    border-radius: 50%;\n    margin-right: 5px;\n}\n.red_summary {\n    background-color: #FF5242;\n}\n.blue_summary {\n    background-color: #6457E8;\n}\n.summary_stat {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    height: 20px;\n    margin-bottom: 6px;\n}\n.summary_stat > p {\n    font-size: 11px;\n    font-weight: 500;\n    color: #767493;\n    letter-spacing: 0.5px;\n    margin-right: 7px;\n    text-align: right;\n    vertical-align: baseline;\n}\n.summary_stat > span {\n    font-size: 12px;\n    padding-left: 7px;\n    font-weight: 600;\n}\n\n.summary_stat > img {\n    margin-left: 10px;\n    padding-bottom: 2px;\n}\n\n@media (max-width: 1300px) {\n    .summary_opt_container {\n        height: 30px;\n        font-size: 12px;\n        min-width: 120px;\n    }\n    .summary_opt {\n        padding: 3px;\n    }\n    .summary_opt_selected {\n        padding: 5px;\n    }\n}\n.summary_chart_container {\n    max-width: 100%;\n    width: 100%;\n    padding-top: 20px;\n    height: 320px;\n}\n\n@media (max-width: 400px) {\n    .summary_opt_container {\n        position: absolute;\n        right: 10px;\n        top: 46px;\n    }\n}\n@media (max-width: 350px) {\n    .summary_opt_container {\n        right: 10px;\n        top: 60px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
